import { Component, ViewEncapsulation, AfterViewInit, OnInit, ChangeDetectorRef } from '@angular/core';
import { ModalDragService } from 'src/app/services/modal.service';
import { DatatableService } from 'src/app/services/datatable.service';
import { ClientService } from 'src/app/services/user/client.service';
import { DestructorComponent } from 'src/app/components/destructor/destructor.component';
import { ClientAccountModalService } from 'src/app/services/client-account-modal/client-account-modal.service';

@Component({
  selector: 'app-sales-payment-client-account-modal',
  templateUrl: './sales-payment-client-account-modal.component.html',
  styleUrls: ['./sales-payment-client-account-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SalesPaymentClientAccountModalComponent extends DestructorComponent implements OnInit, AfterViewInit {

  showPaymentHistory = false;
  showInvoiceHistory = false;
  clientData: any = null;
  isLoading = true;
  hasError = false;
  errorMessage = '';
  customerId: string | null = null;
  showAllocateAmount = false;
  fakeRows = Array.from({ length: 15 });

  constructor(
    private modalDragService: ModalDragService,
    private datatableService: DatatableService,
    private clientService: ClientService,
    private clientAccountModalService: ClientAccountModalService,
    private cdr: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit(): void {
    this.setupModalListener();
    this.setupServiceSubscription();
  }

  private setupServiceSubscription(): void {
    this.subscriptions.push(
      this.clientAccountModalService.selectedCustomerId$.subscribe(customerId => {
        if (customerId) {
          this.customerId = customerId;
        }
      })
    );
  }

  ngAfterViewInit(): void {
    this.modalDragService.makeDraggableByClass('draggable-modal');
  }

  private setupModalListener(): void {
    const modalElement = document.getElementById('kt_manage_deposits_client_account_modal');
    if (modalElement) {
      modalElement.addEventListener('shown.bs.modal', () => {
        console.log('Modal opened, checking for customer data...');
        // First check service
        const serviceCustomerId = this.clientAccountModalService.getSelectedCustomerId();
        if (serviceCustomerId) {
          console.log('Using customer ID from service:', serviceCustomerId);
          this.customerId = serviceCustomerId;
          this.loadClientData(serviceCustomerId);
        } else if (this.customerId) {
          console.log('Using stored customer ID:', this.customerId);
          this.loadClientData(this.customerId);
        } else {
          console.warn('No customer ID available');
        }
      });

      modalElement.addEventListener('hidden.bs.modal', () => {
        this.resetModalData();
        this.clientAccountModalService.clearSelectedCustomerId();
      });
    }
  }

  setCustomerId(customerId: string): void {
    this.customerId = customerId;
  }

  private loadClientData(customerId: string): void {
    this.isLoading = true;
    this.hasError = false;
    this.errorMessage = '';

    this.subscriptions.push(
      this.clientService.GetDataById(customerId).subscribe({
        next: (response) => {
          if (response.status && response.data) {
            this.clientData = response.data;
            this.hasError = false;
            console.log('Client data loaded:', this.clientData);
          } else {
            this.hasError = true;
            this.errorMessage = 'No client data found';
            this.clientData = null;
          }
          this.isLoading = false;

          // Force change detection
          this.cdr.detectChanges();
        },
        error: (error) => {
          console.error('Error loading client data:', error);
          this.hasError = true;
          this.errorMessage = 'Failed to load client data. Please try again.';
          this.clientData = null;
          this.isLoading = false;

          // Force change detection
          this.cdr.detectChanges();
        }
      })
    );
  }

  private resetModalData(): void {
    this.clientData = null;
    this.customerId = null;
    this.showPaymentHistory = false;
    this.showInvoiceHistory = false;
    this.hasError = false;
    this.errorMessage = '';
    this.isLoading = false;
  }

  togglePaymentHistory(): void {
    this.showPaymentHistory = !this.showPaymentHistory;

    if (this.showPaymentHistory) {
      setTimeout(() => {
        this.datatableService.init('kt_payment_history');
      }, 0);
    }
  }

  toggleInvoiceHistory(): void {
    this.showInvoiceHistory = !this.showInvoiceHistory;

    if (this.showInvoiceHistory) {
      setTimeout(() => {
        this.datatableService.init('kt_invoice_history');
      }, 0);
    }
  }

  formatDate(dateString: string): string {
    if (!dateString) return '--';
    const date = new Date(dateString);
    return date.toLocaleDateString();
  }

  getOpeningBalanceDisplay(): string {
    if (!this.clientData?.opening_balance) return '--';
    const type = this.clientData.opening_balance_type === 'debit' ? 'Dr.' : 'Cr.';
    return `$ ${this.clientData.opening_balance} ${type}`;
  }

  onDepositSelected(deposit: any): void {
    console.log('Deposit selected:', deposit);
  }

  onAllocationChanged(allocations: any[]): void {
    console.log('Allocations changed:', allocations);
  }

}
